/**
 * Returns the entries in `newer` that do not exist in `older` with the same
 * value.
 *
 * Example:
 * filterUnmatchedEntries(
 *  { a: 1, b: 'two', c: 3 },
 *  { a: 1, b: 2 }
 * ) // Returns { b: 2 }
 */
export function filterUnmatchedEntries<T extends Record<string, unknown>>(
    a: Record<string, unknown>,
    b: T,
): Partial<T> {
    return Object.entries(b).reduce((acc, [key, value]) => {
        return a[key] === value ? acc : { ...acc, [key]: value };
    }, {});
}
